import React from 'react';
import { branch } from 'baobab-react/higher-order';
import LabelActions from '../../../actions/LabelActions';
import { NotificationManager } from 'react-notifications';

class LabelsSuperUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      myLabels: [],
      selectedLabels: [],
    };
  }

  componentDidMount = async () => {
    const { contract } = this.props;

    try {
      const myLabels = await LabelActions.getAllMyLabels(
        contract.rootUser || contract.createdBy,
        'list',
      );
      this.setState({ myLabels });
    } catch (error) {
      console.error('Error loading labels:', error);
      NotificationManager.error(
        'Hubo un error al obtener el listado de etiquetas',
        'Error',
        10000,
      );
    }
  };

  signerOrAdminInputChange = async (e) => {
    const { contract } = this.props;
    const { selectedLabels, myLabels } = this.state;
    const labelId = e.target.value;

    const numberLabelId = Number(labelId);

    const labelToAdd = myLabels.find((label) => label.id === numberLabelId);
    if (!labelToAdd) {
      return NotificationManager.error(
        'Etiqueta no encontrada',
        'Error',
        10000,
      );
    }

    // Check if label is already selected
    if (selectedLabels.some((label) => label.id === numberLabelId)) {
      return NotificationManager.error(
        'La etiqueta ya ha sido agregada al contrato',
        'Error',
        10000,
      );
    }

    //Verify if contract.labels contains the label
    if (
      contract.labels &&
      contract.labels.some((label) => label.id === numberLabelId)
    ) {
      return NotificationManager.error(
        'La etiqueta ya está asignada al contrato',
        'Error',
        10000,
      );
    }

    try {
      this.setState({
        selectedLabels: [...selectedLabels, labelToAdd],
      });
    } catch (error) {
      console.error('Error assigning label:', error);
      NotificationManager.error(
        'Hubo un error al asignar la etiqueta al contrato',
        'Error',
        10000,
      );
    }
  };

  handleSubmit = async () => {
    const { contract, handleCancel, searchContractsById } = this.props;
    const { selectedLabels } = this.state;

    try {
      for (const label of selectedLabels) {
        const isAssigned = contract.labels?.some(
          (assignedLabel) => assignedLabel.id === label.id,
        );

        if (isAssigned) continue;

        await LabelActions.assign({
          contract: contract.id,
          label: label.id,
          rootUser: contract.rootUser,
        });
      }
      NotificationManager.success(
        'Etiquetas asignadas correctamente',
        'Éxito',
        10000,
      );
      if (searchContractsById) searchContractsById();
      handleCancel();
    } catch (error) {
      console.error('Error assigning labels:', error);
      NotificationManager.error(
        'Hubo un error al asignar las etiquetas al contrato',
        'Error',
        10000,
      );
    }
  };

  render() {
    const { contract, handleCancel } = this.props;
    const { myLabels, selectedLabels } = this.state;

    return (
      <>
        <div className="modal-container mtm-20">
          <div
            className="modal"
            style={{
              width: 900,
              margin: '22vh auto 0px auto',
            }}
          >
            <h2>Etiquetas del contrato ya guardadas</h2>
            <div className="row" style={{ paddingBottom: 20, paddingLeft: 10 }}>
              {contract?.labels?.length ? (
                <div className="list_labels">
                  {contract.labels.map((label, i) => (
                    <span
                      className="all_labels"
                      style={{ background: label.color }}
                      key={`label-${i}`}
                    >
                      {label.content}
                    </span>
                  ))}
                </div>
              ) : (
                <small>No hay etiquetas</small>
              )}
            </div>

            <p>Agregar etiquetas al contrato</p>

            <div className="content-select-1">
              <select
                name="labels"
                className="select_labels"
                onChange={(e) => this.signerOrAdminInputChange(e)}
              >
                <option style={{ fontWeight: 'bold' }}>
                  Selecciona una etiqueta
                </option>
                {myLabels.map((label) => (
                  <option key={label.id} value={label.id}>
                    {label.content}
                  </option>
                ))}
              </select>
              <i
                className="fas fa-chevron-down"
                style={{ right: 11, top: 'calc(50% - 3px)' }}
              ></i>
            </div>

            <div className="list_labels">
              {selectedLabels.length
                ? selectedLabels.map((chip, i) => (
                    <span
                      key={i}
                      style={{ background: chip.color }}
                      className="all_labels"
                    >
                      {chip.content}
                    </span>
                  ))
                : null}
            </div>

            <div
              className="col-sm-12"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <button
                type="button"
                className="secondary"
                onClick={handleCancel}
                style={{ color: 'black' }}
              >
                Regresar
              </button>
              <button
                type="button"
                className="primary"
                onClick={this.handleSubmit}
                disabled={selectedLabels.length === 0}
                style={{ color: 'white' }}
              >
                Guardar
              </button>
            </div>
          </div>
          <div className="background-screen" />
        </div>
      </>
    );
  }
}

export default branch(
  {
    session: ['session'],
  },
  LabelsSuperUser,
);
